import dayjs from 'utils/dayjs';
import { DEFAULT_MOBILE_DATE_FORMAT, dumpCurrencyRates, request } from 'utils';

import {
  FETCH_VA_RATES_REQUEST,
  FETCH_VA_RATES_SUCCESS,
  FETCH_VA_RATES_FAILURE,
  FETCH_VA_EXCHANGERS_LIST_REQUEST,
  FETCH_VA_EXCHANGERS_LIST_FAILURE,
  FETCH_VA_EXCHANGERS_LIST_SUCCESS,
} from 'actionTypes';

export const fetchExchangersRates = params => async dispatch => {
  const {
    date = dayjs().format(DEFAULT_MOBILE_DATE_FORMAT),
    city = null,
    intl: { locale = 'uk' },
  } = params;
  const requestCurrency = 'currency=usd&currency=eur&currency=pln';

  dispatch({
    type: FETCH_VA_RATES_REQUEST,
    payload: {
      cityKey: city || 'all',
      dateKey: date,
    },
  });

  try {
    const { items } = await request({
      url: `${process.env.APP_VA_RATES_API}?${requestCurrency}`,
      params: { city, date, group: 'day' },
    });

    return dispatch({
      type: FETCH_VA_RATES_SUCCESS,
      payload: {
        cityKey: city || 'all',
        dateKey: date,
        entities: dumpCurrencyRates(items, locale, city),
      },
    });
  } catch (error) {
    return dispatch({
      type: FETCH_VA_RATES_FAILURE,
      payload: {
        cityKey: city || 'all',
        dateKey: date,
      },
    });
  }
};

export const fetchExchangersList = params => async dispatch => {
  const {
    currency,
    city = null,
    intl: { locale = 'uk' },
  } = params;

  dispatch({
    type: FETCH_VA_EXCHANGERS_LIST_REQUEST,
    payload: {},
  });

  try {
    const response = await request({
      url: `${process.env.APP_VA_API_DOMAIN}/api/v2/exchangers`,
      params: { city, currency, locale },
    });
    const data = response?.data || response || [];

    return dispatch({
      type: FETCH_VA_EXCHANGERS_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    return dispatch({
      type: FETCH_VA_EXCHANGERS_LIST_FAILURE,
      payload: {},
    });
  }
};
